// ABOUTME: Help-icon explainer for the Retourkosten (return costs) tab.
// ABOUTME: Explains overlap priority (order wins) and the no-match fallback to the default cost.

import { Box } from "@mui/material";
import { useTranslation } from "react-i18next";
import ExplainerModal from "../../../../theme/Modal/ExplainerModal/ExplainerModal";
import ExplainerBox from "../../../../theme/Modal/ExplainerModal/ExplainerBox";

const EMReturnCosts = () => {
    const { t } = useTranslation();

    return (
        <ExplainerModal>
            <Box
                sx={{
                    display: "flex",
                    flexDirection: "column",
                    gap: 2,
                }}
            >
                <ExplainerBox
                    variant="orange"
                    title={t("return_costs_overlap_title")}
                    text={"return_costs_overlap_explainer"}
                />
                <ExplainerBox
                    title={t("return_costs_nomatch_title")}
                    text={"return_costs_nomatch_explainer"}
                />
            </Box>
        </ExplainerModal>
    );
}

export default EMReturnCosts;
